import * as React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import {StandardProps} from '@material-ui/core';
import Badge, {BadgeProps} from '@material-ui/core/Badge';
export interface TextBubbleProps extends Partial<BadgeProps> {
  text: string | number;
}

type TextBubbleClassKey = 'root';

const styles = (theme: Theme) => ({
  badge: {
    '&:not($colorPrimary):not($colorSecondary)': {
      backgroundColor: theme.palette.grey[600],
    },
    color: theme.palette.grey[50],
    marginLeft: 10,
    transform: 'none',
    position: 'initial' as 'initial',
    padding: '0px 6px',
  },
  colorPrimary: {},
  colorSecondary: {},
});
const TextBubble: React.FunctionComponent<StandardProps<TextBubbleProps, TextBubbleClassKey>> = props => {
  const {text, ...other} = props;
  return <Badge children={[]} showZero max={Infinity} badgeContent={text} {...other} />;
};

export default withStyles(styles)(TextBubble);
